import { render, staticRenderFns } from "./EditPageVisa.vue?vue&type=template&id=135742e6"
import script from "./EditPageVisa.vue?vue&type=script&lang=js"
export * from "./EditPageVisa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports